module.exports = __webpack_public_path__ + "img/Group 788one2.f04b5277.svg";